import { useApp } from '../app-context';
import { PoliciesList } from '../components/PoliciesList';
import { BanneredMenu } from '../components/BanneredMenu';
import { ClaimsList } from '../components/ClaimsList';
import { TSPage } from '../components/commons';
import './MainPage.scss';

const MainPage = function ({ name, pageState }) {
    const [state, dispatcher] = useApp();

    const handleOpenClaim = (e) => {
        dispatcher({ action: "showPage", params: { id: "animalSelector" } });
    };

    return (
        < TSPage name={name} pageState={pageState} className="fading" >
            <div className="ts-limiter">
                <BanneredMenu></BanneredMenu>
                <div className="content">
                    <div className="top">
                        <button className="yellow menu-item" onClick={handleOpenClaim}>הגשת תביעה אונליין</button>
                        <a href="tel:*6558" className="dial-link tel menu-item"><img src="/img/tel-dark.svg" alt="tel" /> *6558</a>
                        <h3 className="main-title">התביעות שלי</h3>
                    </div>

                    {!state.profile?.openClaims?.length && !state.profile?.closeClaims?.length && !state.profile?.pendingClaims?.length && state.uiParams.windowSize.w >= 1024 ?
                        <div className="no-claims-banner">
                            <img src="/img/dog-pages-pile.svg" alt="a dog with a pile of pages" />
                            <h3>נראה שאין לך תביעות בחיותא</h3>
                            <div className="exp">במידת הצורך ניתן להגיש תביעה חדשה</div>
                            <button className="yellow" onClick={handleOpenClaim}>הגשת תביעה אונליין</button>
                        </div>
                        :
                        undefined
                    }

                    {state.profile?.openClaims?.length ?
                        <ClaimsList claims={[...state.profile?.pendingClaims, ...state.profile?.openClaims]} title="תביעות בתהליך" />
                        :
                        undefined
                    }

                    {state.profile?.closeClaims?.length ?
                        <ClaimsList claims={state.profile?.closeClaims} title="תביעות שטופלו" />
                        :
                        undefined
                    }

                    {state.profile?.pets?.length ?
                        <PoliciesList policies={state.profile?.pets} />
                        :
                        undefined
                    }
                    <div className="links">
                        <div className="link"><a href="https://chayuta.com/assets/amana.pdf" target="_blank" className="" rel="noopener noreferrer">אמנת שירות</a></div>
                        <div className="link"><a href="https://chayuta.com/assets/accessibility.pdf" target="_blank" className="" rel="noopener noreferrer">הצהרת נגישות</a></div>
                        <div className="link"><a href="https://chayuta.com/assets/teerms.pdf" target="_blank" className="" rel="noopener noreferrer">תנאי שימוש</a></div>
                        <div className="link"><a href="https://chayuta.com/assets/privacy.pdf" target="_blank" className="" rel="noopener noreferrer">פרטיות</a></div>
                    </div>
                </div>
            </div>
        </TSPage >
    );
}

export { MainPage };